<script setup>
import { ref } from 'vue'
import CreateBtnAndModal from '@/components/CreateBtnAndModal';
import PurchasesFileUploadVue from '@/components/exim/PurchasesFileUpload'

const props = defineProps({
  menuItems: [Array, Object],
})
const menuItems = ref(props.menuItems)
const open = ref(false)

</script>

<template>
  <div class="left-menu-wrapper">
    <div class="small-screen-menu" :class="{open}">
      <span v-show="!open" class="material-symbols-outlined" @click="open = !open">menu</span>
    </div>

    <div class="floating-controls-cont">
      <CreateBtnAndModal />
    </div>

    <div class="left-menu-cont flex flex-column" :class="{open}">
      <span v-show="open" class="material-symbols-outlined close" @click="open = !open">close</span>
      <div class="menu-items-cont flex flex-column gap-small">
        <div v-for="(link, i) in menuItems" :key="i" class="menu-item" @click="open = !open">
          <router-link :to="{ name: link.href, params: link.params }" class="link">
            {{ link.name }}
          </router-link>
        </div>
      </div>

      <div class="create-btn-wrapper">
        <CreateBtnAndModal />
      </div>

      <div class="file-upload-wrapper">
        <PurchasesFileUploadVue />
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.left-menu-wrapper {
  padding: $padding;
  height: 100%;
  background-color: color(background);
  border-right: 1px solid color(primary-container);
  
  .floating-controls-cont {
    display: none;
  }

  .left-menu-cont {
    height: 100%;

    .menu-items-cont {
      .menu-item {
        padding: $padding;
        font-weight: $bold;
        text-decoration: none;
      }
    }  

    .create-btn-wrapper {
      margin: $margin;
    }

    .file-upload-wrapper {
      margin-top: auto;
      display: flex;
      justify-content: center;
      margin-bottom: $margin;
    }

    .close {
      display: none;
    }
  }

  .small-screen-menu {
    display: none;
  }
}

@media screen and (max-width: $tablet-break) {
  .left-menu-wrapper {
    padding: 0;
    height: 0;

    .small-screen-menu {
      position: absolute;
      left: 0;
      top: 0;
      padding: $padding;
      transition: left 0.5s;
      display: block;
      cursor: pointer;
    }

    .left-menu-cont {
      position: absolute;
      padding: $padding;
      top: 0;
      left: -300px;
      background-color: color(surface-background);
      height: 100vh;
      width: 300px;
      transition: left 0.5s;
      z-index: 1;

      .close {
        cursor: pointer;
        padding: $padding;
        position: absolute;
        right: $margin;
        top: $margin;
        display: block;
      }

      &.open {
        left: 0;
      }

      .create-btn-wrapper {
        display: none;
      }
    }

    .floating-controls-cont {
      position: absolute;
      bottom: $margin;
      right: $marginMed;
      display: block;
      z-index: 1;
    }
  }
}

@media screen and (max-width: $mobile-break) {
  .small-screen-menu {
  }

  .left-menu-cont {
    width: 95%;
    left: -95%;

    &.open {
      left: 0;
    }
  }
}
</style>
